import { Body } from "@components/Typography";
import { useProjectedChart } from "@hooks";
import { Translations, i18n } from "@i18n";
import { InfoIcon } from "./InfoIcon";
import { useStyles } from "./styles";

export const RateOfReturn = () => {
  const styles = useStyles();

  const { interest, setIsInfoVisible } = useProjectedChart();

  return (
    <div style={styles.container} onClick={() => setIsInfoVisible(true)}>
      <InfoIcon />
      <Body style={styles.text}>
        {i18n.t(Translations.GoalDepositRouteHeaderRateOfReturn, { interest })}
      </Body>
    </div>
  );
};
